import { useState } from 'react'
import { Form, InputNumber, Select, Tabs } from 'antd'
import classes from './web.module.css'
import './aboutTable.css'
import Bread from '../cpn/Bread'
import WebMain from './WebMain'

function Dianshangtaizhang() {
    const [userCount, setUserCount] = useState(1)
    const [yearCount, setYearCount] = useState(1)
    const [price, setPrice] = useState(50)
    const [storageType, setStorageType] = useState('1')

    const calculatePrice = (users, years, type) => {
        if (type === '2') {
            return 3000
        }
        let unitPrice = 20
        switch (years) {
            case 2:
                unitPrice = 16
                break
            case 3:
                unitPrice = 14
                break
            case 4:
                unitPrice = 12
                break
            case 5:
                unitPrice = 10
                break
            default:
                unitPrice = 20
        }
        return users * unitPrice * years
    }

    const handleStorageTypeChange = (key) => {
        setStorageType(key)
        setPrice(calculatePrice(userCount, yearCount, key))
    }

    const handleUserCountChange = (value) => {
        setUserCount(value)
        setPrice(calculatePrice(value, yearCount, storageType))
    }

    const handleYearChange = (value) => {
        setYearCount(value)
        setPrice(calculatePrice(userCount, value, storageType))
    }

    const publicCloudContent = (
        <Form labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} style={{ width: '100%', maxWidth: '100%', border: '1px solid #dddddd', padding: 16 }}>
            <h3 style={{ textAlign: 'center', marginBottom: 20 }}>价格计算器</h3>
            <Form.Item label="用户数">
                <InputNumber min={1} defaultValue={1} style={{ width: '100%' }} onChange={handleUserCountChange} />
            </Form.Item>
            <Form.Item label="购买年限">
                <Select
                    options={[
                        { label: '购买5年,50元/用户', value: 5 },
                        { label: '购买4年,48元/用户', value: 4 },
                        { label: '购买3年,42元/用户', value: 3 },
                        { label: '购买2年,36元/用户', value: 2 },
                        { label: '购买1年,20元/用户', value: 1 },
                    ]}
                    defaultValue={5}
                    style={{ width: '100%' }}
                    onChange={handleYearChange}
                />
            </Form.Item>
            <Form.Item label="价格">
                <h2>￥{price.toFixed(2)}</h2>
            </Form.Item>
        </Form>
    )

    const privateCloudContent = (
        <div style={{ width: '100%', border: '1px solid #dddddd', padding: 16, backgroundColor: '#f9f9f9' }}>
            <h3 style={{ textAlign: 'center', marginBottom: 20 }}>私有云说明</h3>
            <div style={{ lineHeight: 1.8, color: '#666', fontSize: 14 }}>
                <p>
                    <strong>数据存储方式：</strong>
                </p>
                <p>私有云数据存储在企业自己的服务器上，提供更高的数据安全性和控制权。</p>
                <p>
                    <strong>价格：</strong>
                </p>
                <p>
                    私有云版本固定价格：<strong style={{ color: '#1890ff', fontSize: 18 }}>￥3000.00</strong>
                </p>
                <p>
                    <strong>特点：</strong>
                </p>
                <ul style={{ marginLeft: 20, paddingLeft: 0 }}>
                    <li>数据完全自主控制</li>
                    <li>用户数量不限</li>
                    <li>使用年限不限</li>
                    <li>更高的安全性</li>
                </ul>
            </div>
        </div>
    )

    return (
        <WebMain selectedKeys="">
            <div style={{ padding: '12px', display: 'flex', flexDirection: 'column', backgroundColor: '#eee', gap: 12 }}>
                <Bread text="电商台账" />
                <div className={classes.aboutItem3}>
                    <div className={classes.softItem} style={{ width: '100%', maxWidth: '100%', padding: 12 }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
                                <img src="/api/assets/images/application/1756454470_02e934bc1499127edebc.png" alt="" style={{ width: 160, height: 'auto' }} />
                                <div>
                                    <h1 style={{ fontSize: 22 }}>电商台账</h1>
                                    <div>一款针对旅行社电商业务销售台账的管理软件，简洁高效。</div>
                                    <div style={{ marginTop: 12 }}>
                                        <b>计调：</b>记录每笔电商业务的支出。
                                    </div>
                                    <div>
                                        <b>客服：</b>记录每笔电商业务的收入。
                                    </div>
                                    <div>
                                        <b>主播：</b>查看直播室的销售利润。
                                    </div>
                                    <div>
                                        <b>财务：</b>审核销售台账。
                                    </div>
                                    <div>
                                        <b>老板：</b>查询销售台账的网店利润、产品利润和销售人员利润。
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: '100%' }}>
                                <Tabs
                                    defaultActiveKey="1"
                                    onChange={handleStorageTypeChange}
                                    items={[
                                        { key: '1', label: '公有云', children: publicCloudContent },
                                        { key: '2', label: '私有云', children: privateCloudContent },
                                    ]}
                                />
                            </div>
                        </div>
                        <div style={{ backgroundColor: '#eeeeee', padding: 16, marginTop: 12, fontSize: 14 }}>
                            <div>
                                <b>购买方式：</b>请登录淘宝网<a>点击打开</a>或者京东商城<a>前往</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </WebMain>
    )
}

export default Dianshangtaizhang
